'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { isSameAddress } from '@dynamic-labs/wallet-connector-core';
import { WalletIcon } from '@dynamic-labs/wallet-book';
import { isMobile } from '@dynamic-labs/utils';
import { DefaultPromptModal } from '../../../widgets/DynamicWidget/prompts/DefaultPromptModal/DefaultPromptModal.js';
import '../../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../../components/Alert/Alert.js';
import '../../../events/dynamicEvents.js';
import '../../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/sdk-api-core';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../../context/ViewContext/ViewContext.js';
import '../../../utils/constants/colors.js';
import '../../../utils/constants/values.js';
import '../../../shared/consts/index.js';
import '../../../context/CaptchaContext/CaptchaContext.js';
import '../../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import '../../../store/state/nonce/nonce.js';
import '../../../store/state/projectSettings/projectSettings.js';
import '../../../config/ApiEndpoint.js';
import '../../../store/state/user/user.js';
import '../../../locale/locale.js';
import '../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../store/state/primaryWalletId/primaryWalletId.js';
import '../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../context/AccountExistsContext/AccountExistsContext.js';
import '../../../context/UserWalletsContext/UserWalletsContext.js';
import '../../../store/state/connectedWalletsInfo/connectedWalletsInfo.js';
import '../../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../../utils/functions/compareChains/compareChains.js';
import { useThemeContext } from '../../../context/ThemeContext/ThemeContext.js';
import '../../../utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import 'bs58';
import { usePromise } from '../../../utils/hooks/usePromise/usePromise.js';
import '@dynamic-labs/types';
import '../../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../../context/LoadingContext/LoadingContext.js';
import '../../../context/WalletContext/WalletContext.js';
import '../../../utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import 'yup';
import '../../../context/MockContext/MockContext.js';
import '../../CollectUserDataView/useFields.js';
import '../../../context/FieldsStateContext/FieldsStateContext.js';
import '../../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../../store/state/loadingAndLifecycle.js';
import '../../../store/state/walletOptions/walletOptions.js';
import '../../../context/FooterAnimationContext/index.js';
import '../../../components/ShadowDOM/ShadowDOM.js';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../components/OverlayCardBase/OverlayCardTarget/OverlayCardTarget.js';
import '../../../context/WalletGroupContext/WalletGroupContext.js';
import '../../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import 'react-focus-lock';
import '../../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../../components/IconButton/IconButton.js';
import '../../../components/MenuList/Dropdown/Dropdown.js';
import 'formik';
import '../../../utils/hooks/useSubdomainCheck/useSubdomainCheck.js';
import '../../../store/state/sendBalances.js';
import '../../../components/Input/Input.js';
import '../../../components/OverlayCard/OverlayCard.js';
import '../../TransactionConfirmationView/TransactionConfirmationView.js';
import '../../../context/PasskeyContext/PasskeyContext.js';
import '../../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../../context/OnrampContext/OnrampContext.js';
import 'qrcode';
import '../../../widgets/DynamicWidget/views/ReceiveWalletFunds/ReceiveWalletFunds.js';
import '../../../../index.js';
import { MobileWalletRedirectView } from '../../MobileWalletRedirectView/MobileWalletRedirectView.js';
import '../../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../../context/ConnectWithOtpContext/ConnectWithOtpContext.js';
import '../../../context/ConnectWithOtpContext/constants.js';
import '../../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../../context/ErrorContext/hooks/useErrorText/useErrorText.js';
import '../../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../../store/state/connectorsInitializing/connectorsInitializing.js';
import '../../../store/state/tokenBalances.js';
import '../../../shared/utils/functions/getInitialUrl/getInitialUrl.js';
import '../../../components/InlineWidget/InlineWidget.js';
import '../../../components/IsBrowser/IsBrowser.js';
import '../../../components/Popper/Popper/Popper.js';
import '../../../components/Popper/PopperContext/PopperContext.js';
import { QrCodeWrapper } from '../../../components/QrCodeWrapper/QrCodeWrapper.js';

const ReconnectWithQrCodeView = ({ onCancel, onSuccess, connector, expectedAddress, }) => {
    var _a;
    const { t } = useTranslation();
    const { theme: { theme }, } = useThemeContext();
    const { name: themeName } = theme;
    const [qrcodeUri, setQrcodeUri] = useState();
    const [desktopUri, setDesktopUri] = useState();
    const triggeredGetAddress = useRef(false);
    const { retrigger } = usePromise(() => __awaiter(void 0, void 0, void 0, function* () {
        if (triggeredGetAddress.current) {
            return;
        }
        triggeredGetAddress.current = true;
        const publicAddress = yield connector.getAddress({
            onDesktopUri: (uri) => __awaiter(void 0, void 0, void 0, function* () {
                setDesktopUri(uri);
            }),
            onDisplayUri: (uri) => __awaiter(void 0, void 0, void 0, function* () {
                setQrcodeUri(uri);
            }),
        });
        if (publicAddress &&
            isSameAddress(publicAddress, expectedAddress, connector.connectedChain)) {
            onSuccess();
            return;
        }
        yield connector.endSession();
        onCancel();
    }), { deps: [connector], retries: 3 });
    const retryMobileConnection = () => {
        triggeredGetAddress.current = false;
        retrigger();
    };
    return (jsx(DefaultPromptModal, { dataTestId: 'reconnect-qr-code', title: t('dyn_sync_wallet.reconnect_with_qr_code.title'), onClose: onCancel, children: !isMobile() ? (jsx(QrCodeWrapper, { uri: qrcodeUri || '', desktopUri: desktopUri, accentColor: 
            /* istanbul ignore next */
            themeName === 'dark'
                ? theme.colors.textPrimary
                : (_a = connector.metadata.brandColor) !== null && _a !== void 0 ? _a : '', icon: 
            // eslint-disable-next-line react/jsx-wrap-multilines
            jsx(WalletIcon, { icon: connector.metadata.icon, walletKey: connector.key }), showCopyToClipboardButton: true, walletConnector: connector })) : (jsx(MobileWalletRedirectView, { onRetry: retryMobileConnection, connector: connector })) }));
};

export { ReconnectWithQrCodeView };
